export default "__VITE_ASSET__BxfjUKVM__"